import ko from "knockout";
import featureToggleService from "services/featureToggleService";

/**
 * A binding handler for including a section of markup in the document (
 * and to have its data-bind attributes applied), only if a specified feature flag is enabled.
 *
 * # Required arguments
 *
 * @param {String} value - The name of the feature flag that should be checked
 *
 * # Example
 *
 * <!-- ko featureToggle: 'conferencing' -->
 *     <div></div>
 * <!-- /ko -->
 *
 */
ko.bindingHandlers.featureToggle = {
    init(element, valueAccessor, allBindings, viewModel, bindingContext) {
        // Initially hide everything to not show hidden features for a little bit before the feature toggles are
        // fetched for the first time.
        const feature = ko.unwrap(valueAccessor()),
            visible = featureToggleService.getFeatureToggle(feature);

        ko.bindingHandlers.if.init(
            element,
            visible,
            allBindings,
            viewModel,
            bindingContext
        );

        // Prevent inner bindings from being bound twice
        return { controlsDescendantBindings: true };
    },
};

ko.virtualElements.allowedBindings.featureToggle = true;
